import { AccountTicketDetails, TenantOptionsDetails } from "features/types";
import { formatCurrency } from "utils/appUtils";
import { formatEventDate } from "utils/eventUtils";
import { svgURL } from "utils/fileUtils";

export default (
  ticket: AccountTicketDetails,
  tenantConfig: TenantOptionsDetails
) => {
  const tenantLogo = svgURL(ticket.event.hostName, false);

  const generateContact = () => {
    const supportEmail = tenantConfig.supportEmail;
    const supportPhone = tenantConfig.supportPhone;
    return `<div>
                    <div>
                        If you have any questions, contact us
                        at ${supportEmail ? supportEmail : ""}
                        ${supportEmail && supportPhone ? "or call us at" : ""}
                        ${supportPhone ? supportPhone : ""}
                    </div>
                </div>`;
  };

  const getSubtotal = (accountTicket: AccountTicketDetails) => {
    return accountTicket.tickets.reduce((subtotal, ticket) => {
      return Number(ticket.charge?.totalPrice || 0) + subtotal;
    }, 0);
  };

  const getCredits = (accountTicket: AccountTicketDetails) => {
    return accountTicket.tickets.reduce((subtotal, ticket) => {
      return Number(ticket.charge?.totalCredits || 0) + subtotal;
    }, 0);
  };

  const getPoints = (accountTicket: AccountTicketDetails) => {
    return accountTicket.tickets.reduce((subtotal, ticket) => {
      return Number(ticket.charge?.totalPoints || 0) + subtotal;
    }, 0);
  };

  const getTotal = (accountTicket: AccountTicketDetails) => {
    return accountTicket.tickets.reduce((subtotal, ticket) => {
      return Number(ticket.charge?.totalCreditCardCharges || 0) + subtotal;
    }, 0);
  };

  return `
    <html>
        <head>
            <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scalable=no" />
            <link rel="preconnect" href="https://fonts.googleapis.com">
            <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
            <link href="https://fonts.googleapis.com/css2?family=Roboto&display=swap" rel="stylesheet">
            <style>
                body {
                    max-width:500px;
                    margin: 0 auto;
                    display: flex;
                    flex-direction: column;
                    font-size: 1rem;
                    padding: 12px;
                    font-family: 'Roboto', sans-serif;
                }
                .flex {
                    display: flex;
                }
                .justify-between {
                    justify-content: space-between;
                }
                .no-wrap {
                    flex-wrap: no-wrap;
                }
                .mt-2 {
                    margin-top: 12px;
                }
                .mt-5 {
                    margin-top: 30px;
                }
                .column {
                    flex-direction: column;
                }
                .mr-2 {
                    margin-right: 12px;
                }
                .mb-1 {
                    margin-bottom: 6px;
                }
                .mb-2 {
                    margin-bottom: 12px;
                }
                .text-weight-bold {
                    font-weight: 700;
                }
                .border-bottom {
                    padding-bottom: 6px;
                    border-bottom: 1px solid #cccccc;
                }
                .title {
                    font-size: 1.5rem;
                }
                .text-center {
                    text-align:center;
                }
                .text-right {
                    text-align:right;
                }
                .text-green {
                    color: rgb(22, 163, 74);
                }
            </style>
        </head>
        <body>
            <div class="mt-2"><img src="https://branding.fanrally.com/logos/fanrally_logo_master.png" width="200px"/></div>

            <div class="mt-5">
                <div class="mb-2">
                    <div class="text-weight-bold">${ticket.event.name} </div>
                    <div>${formatEventDate(
                      ticket.event,
                      "ddd &#8226; MMM DD &#8226; hh:mm A"
                    )}</div>
                    <div>
                        ${ticket.event.venueName} - ${ticket.event.venueCity}, 
                        ${ticket.event.venueState}
                    </div>
                </div>

                <div>
                    <div class="text-weight-bold">
                        <div>Payment Details</div>
                    </div>
                    <div>
                        <div class="flex justify-between no-wrap mb-1">
                            <div>Subtotal</div>
                            ${formatCurrency(getSubtotal(ticket))}
                        </div>
                         <div class="flex justify-between no-wrap mb-1 text-green">
                            <div>Points</div>
                            ${formatCurrency(getPoints(ticket))}
                        </div>
                        <div class="flex justify-between no-wrap mb-1 text-green">
                            <div>Credits</div>
                            ${formatCurrency(getCredits(ticket))}
                        </div>
                        <div class="flex justify-between no-wrap mb-1">
                            <div>Total</div>
                            ${formatCurrency(getTotal(ticket))}
                        </div>
                    </div>
                </div>
            </div>

            <div class="mt-2">
                ${generateContact()}
            </div>

            <div class="mt-5 text-center">
                <img src="${tenantLogo}" height="375px" style="opacity: 0.2;width:100%"/>
            </div>
        </body>
    </html>
    `;
};
